import { defaultMemoize } from "reselect";
import { getResourceEdgesByLabelMemo, getResourceEdgeStub, selectorCreators, selectors } from "../../../ducks/resource-edges/selectors";
import { makeParameterizedSelector } from "../../../utils/makeParameterizedSelector";
import { updateUpload } from "./updateUpload";
import { ExtendedUpload } from "../../../../wrapped-cube-client/uploader/extendedupload";
import { createNestedUpload } from "./createNestedUpload";
import { USE_UPLOADS_VERSION_2 } from "@cube3/common/model/schema";
import { getTempThumbnail } from "../../../../../../main/src/components/app/layout/MediaQueue/prefabs/UploadQueueListItem/getTempThumbnail";

const emptyArray = []

export const uploadsEnhancer =
    ({ maxParallelUploads }) =>
        (createStore) => {
            return (...args) => {
                const store = createStore(...args);

                console.info("DEBUG uploadsEnhancer", USE_UPLOADS_VERSION_2)

                if (!USE_UPLOADS_VERSION_2) {
                    return store
                }


                // const uploadSelector = defaultMemoize((workspaceId) => {
                //     return selectorCreators.getResourceEdgeStubsByLabel(workspaceId, 'workspace', 'file-uploads', {})
                // })

                const uploadsPerWorkspaceSelector = makeParameterizedSelector(
                    'uploadsPerWorkspaceSelector',
                    (workspaceId) => {

                        return (query) => {
                            const uploads = query(
                                (state) =>
                                    getResourceEdgesByLabelMemo(
                                        state,
                                        workspaceId ?? undefined,
                                        workspaceId ? 'workspace' : undefined,
                                        'file-uploads',
                                        'file-upload'
                                    ) || emptyArray
                            );


                            const queuedUploads = uploads
                                .map((e) => query((state) => getResourceEdgeStub(state, e)))
                                .filter((u) => !u.__deleted__ && ['queued'].includes(u.status))
                                .filter(u => {
                                    return query((state) => getResourceEdgesByLabelMemo(state, u.id, 'file-upload', 'parent-resource', {})?.length > 0)
                                })




                            const activeUploads = uploads
                                .map((e) => query((state) => getResourceEdgeStub(state, e)))
                                .filter((u) => !u.__deleted__ && ['active'].includes(u.status));



                            return { workspaceId, queued: queuedUploads, active: activeUploads }

                        };
                    },
                    (workspaceId) =>
                        workspaceId ?? null
                );



                const unsub = observeStore(
                    store,
                    (state) => {

                        const activeWorkspace = state.session.workspace;
                        const uploads = uploadsPerWorkspaceSelector(activeWorkspace)(state)
                        return uploads

                    },
                    (state, oldState = { active: emptyArray, queued: emptyArray }) => {


                        if (!state) {
                            return
                        }

                        console.info("DEBUG uploadsEnhancer upload state", state)

                        // if (state.queued.length > 0) {
                        //     state.queued.filter(u => !u.display_image).slice(-2).forEach((u) => {
                        //         getTempThumbnail(u.file.raw).then(({ dataUrl }) => {
                        //             updateUpload(u.id, { display_image: dataUrl }, store.dispatch, store.getState)
                        //         }).catch(() => {
                        //             // ignore
                        //         })
                        //     })
                        // }

                        if (state.active.length < maxParallelUploads && state.queued.length > 0) {
                            const u = state.queued[0];


                            const p = selectors.getResourceEdgesByLabel__unoptimized(store.getState(), u.id, u.type, 'parent-resource', 'folder');


                            if (p) {

                                updateUpload(u.id, { status: 'active' }, store.dispatch, store.getState)



                                createNestedUpload(u.file, p[0], store.dispatch, u.edgeLabel, state.workspaceId)
                            }
                        }

                        // state.active.filter(u => u.file?.raw && !u.tusUpload).forEach(
                        //     u => {

                        //     }
                        // )

                        state.active.filter(u => u.tusUpload && u.progress === 100).forEach(
                            u => {
                                // console.info("DEBUG uploadsEnhancer marking succeeded", u)

                                updateUpload(u.id, { status: 'succeeded', file: null, tusUpload: null }, store.dispatch, store.getState)

                            }
                        )

                        state.active.filter(u => u.tusUpload && (!u.file || Object.keys(u.file).length === 0) || !(u.file.path || u.file.raw?.path)).forEach(
                            u => {
                                // console.info("DEBUG uploadsEnhancer marking failed", u)
                                updateUpload(u.id, { status: 'failed' }, store.dispatch, store.getState)

                            }
                        )



                        // console.info("DEBUG state", state)

                    }
                );



                return store;
            };
        };


let last = 0;

// subcribe to store an do callback if selected state slice changes
// this will be used in the enhancer to hook up callbacks
const observeStore = (store, select, onChange) => {
    let currentState;

    function handleChange() {
        const n = Date.now();

        if (n - last >= 100) {
            const nextState = select(store.getState());
            if (nextState !== currentState) {
                const oldState = currentState;
                currentState = nextState;


                onChange(currentState, oldState);
            }
            last = n
        }
    }

    const unsubscribe = store.subscribe(handleChange);
    handleChange();
    return unsubscribe;
};